import {useCallback} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextTruncate from 'react-text-truncate';
import DOMUtils from '@livongo/utils/dom';
import {PageTypes} from 'utils/page';

const TITLE_MAP = {
    [PageTypes.ICON_PAGE]: 'TITLE',
    [PageTypes.IMAGE_PAGE]: 'TITLE',
    [PageTypes.QUESTION_PAGE]: 'QUESTION',
    [PageTypes.TIP_PAGE]: 'TITLE',
};

const TableOfContents = ({
    pages,
    currentPage,
    isLessonComplete,
    highestPageViewed,
    onPageSelected,
}) => {
    const onPageClick = useCallback(
        ({currentTarget}) => {
            const pageNumber = parseInt(
                DOMUtils.attr(currentTarget, 'data-page-num'),
                10
            );

            if (pageNumber <= highestPageViewed || isLessonComplete) {
                onPageSelected(pageNumber);
            }
        },
        [highestPageViewed, isLessonComplete, onPageSelected]
    );

    return (
        <div className="TableOfContents">
            {pages.map((page, index) => {
                const pageId = page.getPageId();
                const pageNum = page.getPageNumber();
                const title = page
                    .getTextFieldsMap()
                    .get(TITLE_MAP[page.getPageType()])
                    .getTextValue();

                const classes = classNames('TableOfContents-item', {
                    'TableOfContents-item-active':
                        currentPage.getPageId() === pageId,
                });

                return (
                    <button
                        key={pageId}
                        data-page-num={pageNum}
                        disabled={
                            pageNum > highestPageViewed && !isLessonComplete
                        }
                        className={classes}
                        onClick={onPageClick}
                    >
                        <TextTruncate
                            className="TableOfContents-item-title"
                            line={2}
                            truncateText="..."
                            text={title}
                        />
                        <p className="TableOfContents-item-count">
                            {index + 1}
                        </p>
                    </button>
                );
            })}
        </div>
    );
};

TableOfContents.propTypes = {
    pages: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentPage: PropTypes.object.isRequired,
    isLessonComplete: PropTypes.bool.isRequired,
    highestPageViewed: PropTypes.number.isRequired,
    onPageSelected: PropTypes.func.isRequired,
};

export default TableOfContents;
